/**
 * Created by rafael on 28.03.17.
 */
import React, { Component } from 'react';
import VoicePlayer from './VoicePlayer.js';
import { FormControl, Button } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../MapHeader/MapHeader.scss';
import s1 from './TextToSpeech.scss';

class TextToSpeech extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formValue: 'Welcome to G.I.A.P.',
      playTxt: false,
    };
  }
  playTxt = () => {
    this.setState({
      playTxt: true,
    });
  }
  handleChange = (e) => {
    this.setState({ formValue: e });
  }
  onEnd = () => {
    this.setState({ playTxt: false });
  }

  render() {
    return (
      <div className={'navPopups col-sm-3 panel panel-default absolute-popup'}>
        <div className={'panel-heading'}>Syntezator mowy
          <img src={this.props.xbutton} alt="X Button" style={{ float: 'right' }} className="xbutton" onClick={this.props.onSpeakClick}/>
        </div>
        <div className={'panel-body'}>
          <FormControl
            id="speaker"
            label="speaker"
            type="text"
            value={this.state.formValue}
            // placeholder="Welcome to G.I.A.P."
            onChange={(event) => this.handleChange(event.target.value)}
          />
          <Button bsClass="textToSpeechButton" onClick={this.playTxt}>Play</Button>
          {this.state.playTxt === true ?
            <VoicePlayer
              play
              text={this.state.formValue}
              onEnd={this.onEnd}
            /> : null
          }
        </div>
      </div>
    );
  }
}
export default withStyles(s, s1)(TextToSpeech);



// WEBPACK FOOTER //
// src/components/Modals/Speech/TextToSpeech.js